export enum ApprovalStates {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export default ApprovalStates;